module.exports = __webpack_public_path__ + "static/8-d034cd59de96667af582be320edc59d7.png";